(()=>{
  const root=document.querySelector('[data-tf3]');
  if(!root)return;
  const radios=[...root.querySelectorAll('input[name="tf3-color"]')];
  const ctas=[...root.querySelectorAll('[data-tf3-cta]')];
  // Los botones llevan la combinación elegida al formulario; se conservan las UTM que añade terra-launch.js.
  const setCta=value=>ctas.forEach(link=>{
    const url=new URL(link.href,location.href);
    url.searchParams.set('acabado',value);
    link.href=url.pathname+url.search+url.hash;
  });
  const preset=radios.find(radio=>radio.value===new URLSearchParams(location.search).get('acabado'));
  if(preset)preset.checked=true;
  const selected=()=>radios.find(radio=>radio.checked)?.value||'rosa';
  setCta(selected());
  root.addEventListener('change',event=>{if(event.target.name==='tf3-color')setCta(event.target.value);});

  const {gsap,ScrollTrigger}=window;
  if(!gsap||!ScrollTrigger)return;
  gsap.registerPlugin(ScrollTrigger);
  root.classList.add('tf3-js');

  // Divide en palabras para animarlas; el texto completo queda para lectores de pantalla.
  const split=element=>{
    if(element.dataset.tf3Done)return [...element.querySelectorAll('.tf3-w')];
    element.dataset.tf3Done='1';
    const label=element.textContent.replace(/\s+/g,' ').trim();
    const visual=document.createElement('span');
    visual.className='tf3-split';
    visual.setAttribute('aria-hidden','true');
    visual.append(...element.childNodes);
    const walker=document.createTreeWalker(visual,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(node=>{
      const fragment=document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(part=>{
        if(!part)return;
        if(/^\s+$/.test(part)){fragment.append(part);return;}
        const word=document.createElement('span');
        word.className='tf3-w';
        word.textContent=part;
        fragment.append(word);
      });
      node.replaceWith(fragment);
    });
    const accessible=document.createElement('span');
    accessible.className='tf-sr-only';
    accessible.textContent=label;
    element.append(accessible,visual);
    return [...visual.querySelectorAll('.tf3-w')];
  };

  const hero=root.querySelector('.tf3-hero');
  const arch=root.querySelector('[data-tf3-arch]');
  const figs=root.querySelector('[data-tf3-figs]');
  const word=root.querySelector('.tf3-word');
  const title=root.querySelector('.tf3-title');
  const detail=root.querySelector('[data-tf3-detail]');
  const mm=gsap.matchMedia();

  // Horizon desplaza .page-wrapper en lugar de la ventana a partir de 990 px; ScrollTrigger debe escuchar ese contenedor.
  const pageScroller=()=>{
    const wrapper=document.querySelector('.page-wrapper');
    return wrapper&&/(auto|scroll)/.test(getComputedStyle(wrapper).overflowY)&&wrapper.scrollHeight>wrapper.clientHeight?wrapper:window;
  };

  mm.add({motion:'(prefers-reduced-motion: no-preference)',desktop:'(min-width: 901px)',fine:'(pointer: fine)',wrapperScroll:'(min-width: 990px)'},context=>{
    const {motion,desktop,fine}=context.conditions;
    if(!motion)return;
    const scroller=pageScroller();
    const cleanups=[];

    // Entrada: el titular, el botón y el selector se pueden usar desde el primer fotograma.
    const figure=root.querySelector(`.tf3-fig[data-v="${selected()}"]`);
    gsap.timeline({defaults:{ease:'power3.out'}})
      .from(arch,{scaleY:.8,duration:1.1})
      .from(figure,{yPercent:7,rotation:-2.5,duration:1.15},0)
      .from(word,{yPercent:20,autoAlpha:0,duration:1.2},.1)
      .from(split(title),{y:'0.3em',duration:.8,stagger:.035},.05)
      .from(root.querySelectorAll('.tf3-dot'),{scale:.6,duration:.5,stagger:.06,ease:'back.out(2)'},.45);

    // Cambio de color: la figura entrante gira y se asienta; la palabra del fondo sube.
    const onChange=event=>{
      if(event.target.name!=='tf3-color')return;
      const value=event.target.value;
      gsap.fromTo(root.querySelector(`.tf3-fig[data-v="${value}"]`),{yPercent:5,rotation:3,scale:.97},{yPercent:0,rotation:0,scale:1,duration:.9,ease:'power3.out',overwrite:'auto'});
      gsap.fromTo(root.querySelector(`.tf3-word [data-v="${value}"]`),{yPercent:24},{yPercent:0,duration:1,ease:'power3.out',overwrite:'auto'});
    };
    root.addEventListener('change',onChange);
    cleanups.push(()=>root.removeEventListener('change',onChange));

    // Paralaje suave con ratón (figura y arco a distinta profundidad); vuelve al reposo al salir, perder el foco u ocultar la pestaña.
    if(desktop&&fine){
      const archX=gsap.quickTo(arch,'x',{duration:.9,ease:'power3'});
      const figsX=gsap.quickTo(figs,'x',{duration:.9,ease:'power3'});
      const figsY=gsap.quickTo(figs,'y',{duration:.9,ease:'power3'});
      const wordX=gsap.quickTo(word,'x',{duration:1.2,ease:'power3'});
      let frame=0;
      const onMove=event=>{
        if(frame)return;
        frame=requestAnimationFrame(()=>{
          frame=0;
          const box=hero.getBoundingClientRect();
          const dx=(event.clientX-box.left)/box.width-.5;
          const dy=(event.clientY-box.top)/box.height-.5;
          archX(dx*8);figsX(dx*22);figsY(dy*10);wordX(dx*-40);
        });
      };
      const rest=()=>{archX(0);figsX(0);figsY(0);wordX(0);};
      const onVisibility=()=>{if(document.hidden)rest();};
      hero.addEventListener('pointermove',onMove);
      hero.addEventListener('pointerleave',rest);
      window.addEventListener('blur',rest);
      document.addEventListener('visibilitychange',onVisibility);
      cleanups.push(()=>{
        cancelAnimationFrame(frame);
        hero.removeEventListener('pointermove',onMove);
        hero.removeEventListener('pointerleave',rest);
        window.removeEventListener('blur',rest);
        document.removeEventListener('visibilitychange',onVisibility);
      });
    }

    // Escritorio: el detalle pasa de arco a imagen completa y se encienden las tres frases.
    const lines=detail.querySelectorAll('[data-tf3-line]');
    if(desktop){
      detail.classList.add('is-scrub');
      cleanups.push(()=>detail.classList.remove('is-scrub'));
      gsap.timeline({scrollTrigger:{scroller,trigger:detail,start:'top top',end:'bottom bottom',scrub:.6}})
        .fromTo(detail.querySelector('.tf3-detail-media'),{clipPath:'inset(9% 16% 0% 16% round 40vw 40vw 0vw 0vw)'},{clipPath:'inset(0% 0% 0% 0% round 0vw 0vw 0vw 0vw)',ease:'none',duration:1})
        .fromTo(detail.querySelector('[data-tf3-detail-img]'),{scale:1.18},{scale:1,ease:'none',duration:1},0)
        .fromTo(lines,{opacity:.22},{opacity:1,ease:'none',duration:.25,stagger:.3},.1);
    }else{
      gsap.from(lines,{opacity:0,y:18,duration:.7,stagger:.12,ease:'power3.out',scrollTrigger:{scroller,trigger:lines[0],start:'top 85%',once:true}});
    }

    // Titulares palabra a palabra y bloques escalonados.
    root.querySelectorAll('h2[data-tf3-split]').forEach(heading=>{
      gsap.from(split(heading),{yPercent:60,opacity:0,duration:.8,stagger:.05,ease:'power3.out',scrollTrigger:{scroller,trigger:heading,start:'top 86%',once:true}});
    });
    root.querySelectorAll('[data-tf3-stagger]').forEach(group=>{
      gsap.from(group.children,{y:40,opacity:0,duration:.8,stagger:.09,ease:'power3.out',scrollTrigger:{scroller,trigger:group,start:'top 85%',once:true}});
    });
    const rules=root.querySelectorAll('.tf3-rule');
    if(rules.length)gsap.from(rules,{scaleX:0,transformOrigin:'0 50%',duration:1.1,stagger:.15,ease:'power2.inOut',scrollTrigger:{scroller,trigger:rules[0],start:'top 82%',once:true}});

    return()=>cleanups.forEach(cleanup=>cleanup());
  });

  const refresh=()=>ScrollTrigger.refresh();
  window.addEventListener('load',refresh,{once:true});
  document.fonts?.ready.then(refresh);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))mm.revert();});
})();
